module.exports = __webpack_public_path__ + "static/media/DanthaBhagya1.a85f241a.jpeg";